import React from 'react';
import { Paper, Box, Typography, Avatar } from '@mui/material';

const StatCard = ({ label, value, icon, color = 'primary.main' }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      borderRadius: 2.5,
      border: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      transition: 'transform .15s, box-shadow .15s',
      '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
    }}
  >
    <Avatar sx={{ bgcolor: color, width: 44, height: 44, '& svg': { fontSize: 22 } }}>
      {icon}
    </Avatar>
    <Box>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.2 }}>
        {value}
      </Typography>
    </Box>
  </Paper>
);

export default StatCard;